import {createAction} from "redux-act";
import {IContest} from "modules/reducers";

export const requestContest = createAction();
export const requestContestSuccess = createAction<IContest>();
export const requestContestFailed = createAction();

export interface IHelp {
	id: number;
	type: string;
	title: string;
	text: string;
	game?: string;
}

export interface IHelpPagesResponse {
	faqs: IHelp[];
	guidelines: IHelp[];
	terms: IHelp[];
	prizes: IHelp[];
}

export const requestHelpPages = createAction();
export const requestHelpPagesSuccess = createAction<IHelpPagesResponse>();
export const requestHelpPagesFailed = createAction();
